export interface TimeToFirstContact {
  minute: number;
  numberOfContacts: number;
}

export interface StatsResponse {
  popup?: {
    popupClicked?: number;
    popupSubmitted?: number;
    popupShown?: number;
  };
  record: {
    callsCount: number;
    successContactsCount: number;
    timesToFirstContact?: TimeToFirstContact[];
  };
}

export interface Stats {
  impressions: number;
  leads: number;
  contacted: number;
  successes: number;
  timesToFirstContact?: TimeToFirstContact[];
}

export const noStatsToShow = (stats: Stats): boolean =>
  !(stats.impressions || stats.leads || stats.successes || stats.contacted);

export interface CrazyCallHeaders {
  authorization: string;
  account: string;
}

export enum StatsRange {
  TODAY = 'Today',
  LAST_WEEK = 'Last week',
  LAST_MONTH = 'Last month',
  ALL = 'All time'
}
